'use client';

import React from 'react';

import CalendarBarItem, {
    CalendarBarItemStyle,
    CalendarItemStyleCSSProperties
} from '@/app/[locale]/(default-layout)/program/_components/CalendarBarItem';

import { useFormat } from '@cineamo/ui/src/hooks/formatter/useFormat';

import { useDomainConfiguration } from '@/providers/DomainConfigurationProvider';
import { calendarBarLabelInstant, formatDate_yyyyMMdd } from '@/utils/date-helper';

export type CalendarBarDateItemProps = {
    date: Date;
    selectedDate: string;
    setSelectedDate?: (date: string) => void;
    dateItemWidth?: 'w-50' | 'w-80';
    calendarItemStyle?: CalendarBarItemStyle | CalendarItemStyleCSSProperties;
    isActiveItemDisabled?: boolean;
};

export function CalendarBarDateItem(props: CalendarBarDateItemProps): React.JSX.Element {
    const { date, selectedDate, setSelectedDate, calendarItemStyle, dateItemWidth } = props;

    const { timeZone } = useDomainConfiguration();
    const format = useFormat({ timeZone });
    const labelDate = calendarBarLabelInstant(date, timeZone);

    const weekday = format.dateTime.formatWeekday(labelDate).replace('.,', '');
    const dayAndMonth = format.dateTime.formatDate(labelDate, {
        day: '2-digit',
        month: '2-digit'
    });
    const dateForUrl = formatDate_yyyyMMdd(date);
    const accessibilityLabel = format.dateTime.formatDate(labelDate, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
    });

    return (
        <CalendarBarItem
            isItemActive={!props.isActiveItemDisabled && selectedDate === dateForUrl}
            isItemSelected={Boolean(dateForUrl) && selectedDate === dateForUrl}
            onItemClick={
                setSelectedDate
                    ? () => {
                          setSelectedDate(dateForUrl);
                      }
                    : undefined
            }
            dateItemWidth={dateItemWidth}
            calendarItemStyle={calendarItemStyle}
            title={weekday.toUpperCase()}
            subtitle={dayAndMonth}
            accessibilityLabel={accessibilityLabel}
        />
    );
}
